<template>
<el-table-wrapper ref="receiveTable" :data="receiveMsgDatas" :columns="tableColumn" header-align="center" fit-height :row-class-name="checkMessage" :total="total" :column-default="columnDefault" remote pagination @condition-change="onTableConditionChange"
  highlight-current-row :show-search-tool="showSearchTool" :show-custom-header="true" @current-change="handleCurrentChange" @selection-change="changeHandleSelection" @expand-change="expandChange"
  >
  <template #expand-col="props">
    <el-form :model="props.row" label-width="135px">
      <el-form-item label="보낸이">{{ props.row.senderName }} ({{ getDate(null, null, props.row.registDatetime) }})</el-form-item>
      <el-form-item label="받는사람">{{ props.row.messageTargets }}</el-form-item>
      <el-form-item label="내용">
        <div v-html="props.row.messageContents"></div>
      </el-form-item>
      <el-form-item label="첨부파일">
        <span v-for="(file, index) in props.row.fileList" :key="index" style="margin-right: 5px; cursor: pointer;" @click="downloadFile(props.row.seqNumber, file)">
          <i class="far fa-file-download" style="margin-right: 2px; align: left;"></i>{{ file.attachFilename }}.{{ file.attachFiletype }}
        </span>
      </el-form-item>
      <el-row type="flex" justify="end">
          <el-button class="mr-r4" type="primary" @click="replyMessage">답장</el-button>
          <el-button @click="deleteReceiveMessage">삭제</el-button>
      </el-row>
    </el-form>
  </template>

  <template #sender-col="scope">
    <span class="c-pointer" @click="expandTrigger(scope.row)">{{scope.row.senderName}}</span>
  </template>
  <template #contents-col="scope">
    <span class="c-pointer" @click="expandTrigger(scope.row)">
      <div v-html="scope.row.messageContents"></div>
    </span>
  </template>
  <template #file-col="scope">
    <i v-if="scope.row.fileList.length > 0" class="far fa-file-download"></i>
  </template>
</el-table-wrapper>
</template>

<script>
import { isNil, findIndex } from 'lodash';
import userApi from '@/api/frame/user';
import { columnDefault } from '@/constants/table';
import { getDateToString } from '@/utils/date';
import msgUtil from '@/utils/message';

export default {
  name: 'WReceiveMessageTable',
  props: {
    showSearchTool: {
      type: Boolean,
      default: false,
    },
    currentActiveTab: {
      type: String,
    },
  },
  data() {
    return {
      columnDefault,
      total: null,
      receiveMsgDatas: [],
      tableColumn: [
        {
          align: 'center',
          type: 'expand',
          scopedSlot: 'expand-col',
        },
        {
          align: 'center',
          type: 'selection',
          width: '50px',
        },
        {
          prop: 'senderName',
          label: '보낸이',
          searchable: true,
          remoteProp: 'm.manager_name',
          sortable: true,
          scopedSlot: 'sender-col',
        },
        {
          prop: 'messageContents',
          label: '내용',
          searchable: true,
          formatter: this.getTableMessageContents,
          remoteProp: 'message_contents',
          sortable: true,
          scopedSlot: 'contents-col',
        },
        {
          prop: 'registDatetime',
          label: '받은시각',
          width: '150px',
          formatter: this.getDate,
          searchable: true,
          searchType: 'date',
          remoteProp: 'em.regist_datetime',
          sortable: true,
        },
        {
          label: '파일',
          width: '60px',
          scopedSlot: 'file-col',
          align: 'center',
        },
      ],
      selectedMessage: {},
      selectedMessages: [],
      params: {},
    };
  },
  watch: {
    currentActiveTab: {
      handler(val) {
        if (val === 'receive') {
          this.selectedMessage = {};
          this.selectedMessages = [];
          this.loadData();
        }
      },
    },
  },
  methods: {
    /**
     * 받은 쪽지 조회
     * @author kimjy
     */
    loadData() {
      const tableParams = this.$refs.receiveTable.getParameter();
      userApi.getReceiveMessageList(tableParams).then((response) => {
        if (response.data.success) {
          this.receiveMsgDatas = response.data.data;
          if (!isNil(this.selectedMessage)) {
            this.$nextTick(() => {
              this.$refs.receiveTable.$children[0].setCurrentRow(this.selectedMessage);
            });
          }
        }
      });
    },
    getDate(row, column, value) {
      return getDateToString(new Date(value));
    },
    changeHandleSelection(selectVal) {
      this.selectedMessages = selectVal;
    },
    expandChange(row, expandedRows) {
      // expandedRows에 속해있으면 Open 이라고 판단
      const index = findIndex(expandedRows, ['seqNumber', row.seqNumber]);
      // 해당 row가 Open 되었고, checkDatetime 값이 없을 경우 읽음 표시'
      if (index > -1 && (isNil(row.checkDatetime) || row.checkDatetime < 0)) {
        const checkDatetime = new Date().getTime();
        const params = {
          seqNumber: row.seqNumber,
          checkDatetime,
        };
        userApi.readMessage(params).then((response) => {
          if (response.data.success) {
            this.$emit('update-count', response.data.data);
            row.checkDatetime = checkDatetime;
          }
        });
      }
    },
    expandTrigger(row) { // 보낸이, 내용 클릭했을 경우에도 expand
      this.$refs.receiveTable.$children[0].toggleRowExpansion(row);
    },
    checkMessage({ row }) {
      if (isNil(row.checkDatetime) || row.checkDatetime < 0) {
        return 'table-point';
      }
      return '';
    },
    /**
     * 파일 다운로드
     * @author kimjy
     * @param  {Integer} seqNumber
     * @param  {Object} file
     */
    downloadFile(seqNumber, file) {
      const params = {
        seqNumber,
        attachFilename: file.attachFilename,
      };
      userApi.downloadMessageFile(params);
    },
    /**
     * 받은 쪽지 삭제
     * @author kimjy
     */
    deleteReceiveMessage() {
      if (this.selectedMessages.length > 0 || !isNil(this.selectedMessage.seqNumber)) {
        const target = '받은 쪽지';
        const action = msgUtil.action.DELETE;
        if (this.selectedMessages.length === 0) {
          this.selectedMessages.push(this.selectedMessage);
        }
        this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
          userApi
            .deleteReceiveMessage(this.selectedMessages)
            .then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.loadData();
                this.$emit('update-count');
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            })
            .catch((e) => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
              throw new Error(e);
            });
        });
      } else {
        this.$message(msgUtil.getRequireMsgData('선택', '쪽지'));
      }
    },
    handleCurrentChange(val) {
      this.selectedMessage = val;
    },
    replyMessage() {
      if (isNil(this.selectedMessage.seqNumber)) {
        this.$message(msgUtil.getRequireMsgData('선택', '쪽지'));
      } else {
        this.$emit('show-send-message-form', this.selectedMessage);
      }
    },
    getMessageContents(messageContents) {
      return messageContents.split('\n').join('<br />');
    },
    getTableMessageContents(row, column, value) {
      return value.split('\n')[0];
    },
    onTableConditionChange() {
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/frame/components/popup/ReceiveMessageTable.vue